import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { FrequencyProvider } from './context/FrequencyContext';

import Home from './pages/Home';
import Apply from './pages/Apply';
import CreatorDashboard from './pages/CreatorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

import CreatorLogin from './pages/creator/CreatorLogin';
import CreatorSetup from './pages/creator/CreatorSetup';

function App() {
  return (
    <FrequencyProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<Apply />} />

          {/* Creator Auth */}
          <Route path="/creator/login" element={<CreatorLogin />} />
          <Route path="/creator/setup" element={<CreatorSetup />} />

          {/* Creator Routes */}
          <Route element={<ProtectedRoute allowedRoles={['creator', 'admin']} redirectPath="/creator/login" />}>
            <Route path="/creator/*" element={<CreatorDashboard />} />
          </Route>

          {/* Admin Routes */}
          <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Route>

        </Routes>
      </BrowserRouter>
    </FrequencyProvider>
  );
}

export default App;